import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { guardAuthRoute } from './authGuard'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'login', component: () => import('@/views/LoginView.vue'), meta: { guest: true } },
    { path: '/', name: 'dashboard', component: () => import('@/views/DashboardView.vue') },
    { path: '/walls', name: 'walls', component: () => import('@/views/MonitorWallView.vue') },
    // A display opens this address once and is left running on it, so the page
    // carries no session, no navigation and nothing to sign in to.
    { path: '/wall/:id', name: 'public-wall', component: () => import('@/views/PublicWallView.vue'), meta: { public: true } },
    { path: '/recordings', name: 'recordings', component: () => import('@/views/RecordingsView.vue') },
    { path: '/ai/events', name: 'ai-events', component: () => import('@/views/AIEventsView.vue') },
    { path: '/ai/captures', name: 'ai-captures', component: () => import('@/views/AIFaceCapturesView.vue') },
    { path: '/ai/cameras', name: 'ai-cameras', component: () => import('@/views/AICamerasView.vue') },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

router.beforeEach((to) => guardAuthRoute(to, useAuthStore()))

export default router
